export const DEFAULT_SUPERUSER_ORG_ID = "80699418-110c-45b5-aae5-fd5086f0c34d";

export const DEFAULT_HE_TEMPLATE_ORG_ID = "71588713-570a-73d1-cde9-ef1887c5d12e";
